/**
 * /cli/authorize の日本語（en.cliAuth.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。表記の決め事は ja.ts の冒頭と同じ。
 */
import type { enCliAuth } from './en.cliAuth';

type CliAuthMessages = { [K in keyof typeof enCliAuth]: string };

export const jaCliAuth: CliAuthMessages = {
  'cliAuth.title': 'このパソコンでログインしますか？',
  'cliAuth.lead': 'このパソコンから、アプリを作ったり公開したりできるようになります。',
  'cliAuth.safety': '自分でログインしようとしていなければ「やめる」を押してください。',
  'cliAuth.pasteHint': 'このあと「127.0.0.1 に接続できない」と出たら、アドレス欄の URL を全部コピーして、コマンドを実行した所（AI に頼んだならその会話）に貼ってください。',
  'cliAuth.signedInAs': '{email} でログイン中',
  'cliAuth.device': '端末（CLI が名乗った名前）',
  'cliAuth.deviceUnknown': '名乗っていません',
  'cliAuth.time': '求められた時刻',
  'cliAuth.warning': 'いま自分で {connect} か {login} を実行したときだけ「許可」を押してください。誰かから送られたリンクなら「やめる」を押してください。',
  'cliAuth.grants':
    '許可すると、CLI があなたとしてログインします（このブラウザと同じ）。プロジェクトの作成・デプロイ・設定の変更ができます。CLI がログインするとメールでお知らせします。ログアウトはその CLI で logout を実行してください。',
  'cliAuth.allow': 'ログインする',
  'cliAuth.cancel': 'やめる',
  'cliAuth.unverifiedThen': 'メールの確認が済んだら、このページを再読み込みしてください（またはパソコンでもう一度ログインを始めてください）。',
  'cliAuth.unexpectedRedirect': '思わぬ応答が返ってきたため、何も送っていません。パソコンでもう一度ログインを始めてください。',
  'cliAuth.allowedTitle': 'ログインしました',
  'cliAuth.allowedBody': 'パソコンの画面に戻ってください。このタブは閉じてかまいません。',
  'cliAuth.cancelledTitle': 'やめました',
  'cliAuth.cancelledBody': 'ログインはしていません。このタブは閉じてかまいません。',
  'cliAuth.invalidTitle': 'このリンクは使えません',
  'cliAuth.invalidBody': 'リンクが途中で切れているか、書き換えられています。端末で {login} か {connect} をもう一度実行してください（新しいリンクが開きます）。'
};
